//GeneratorFlag:[NoChange]
import KeyValue from './key-value';

export default {KeyValue}
export{KeyValue}